// extracted by mini-css-extract-plugin
export default {"cls1":"CoralNewUserDiscountButton-cls1___55b153ac9bc2eab77e6","cls2":"CoralNewUserDiscountButton-cls2___5b142f247abc7dd4c19 CoralNewUserDiscountButton-cls1___55b153ac9bc2eab77e6"};